import React, { useState, useEffect, useRef } from 'react';
import { deleteCookie, getAppUser, getFactviewUsername, getCurrentUser, getCookie} from '../../functions/utils';
import '../../css/header.css';
import '../../css/ProfileComponent.css';
import FactviewLogoSmall from '../../images/FactviewLogoSmall.png';
import ExactSmall from '../../images/ExactSmall.png';
import TwinfieldSmall from '../../images/TwinfieldSmall.png';
// Import the core library and icon packs you need
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircleUser, faUser, faArrowRightFromBracket, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslations  } from '../utilities/TranslationContext';


// Add the icons you will use to the library
library.add(faCircleUser, faUser, faArrowRightFromBracket, faXmark);

const ProfileComponent = () => {
  const [appUser, setAppUser] = useState(false);
  const { getTranslation } = useTranslations();
  
  useEffect(() =>{
    fetchAppUser();
  }, []); 

  useEffect(() =>{
  }, [appUser]); 

  async function logout() {
    await fetch('https://monitor.factview.nl/?logout=1', {
      method: 'GET',
      credentials: 'include', // Send cookies with the request if needed
    }).then(response => {
      if (response.ok) {
        console.log('Logout successful');  
        
      } else {
        throw new Error('Logout failed');
      }
    }).catch(error => console.error('Error during logout:', error));
    await deleteCookie("factview_access");
    await deleteCookie("factview_refresh"); 
    await deleteCookie("session_id");
    // window.location.href = 'https://importmodule.factview.nl/app';
  }

  async function fetchAppUser(){
    var appUser = await getAppUser();
    if(appUser){
      var userName = await getFactviewUsername();
      appUser.user_name = userName.user_name;
      setAppUser(appUser);
    }
  }
  async function LogoutFactview(){
    let isExecuted = window.confirm(getTranslation("import_LogoutConfirmFactview"));
    if(isExecuted)
    {
      const response = await fetch('/app_user/logoutFactview?user_id='+await getCurrentUser());
      if (response.ok) {
        const responseData = await response.json();
        console.log(responseData);
        const clientId = process.env.REACT_APP_CLIENT_ID_FACTVIEW;
        deleteCookie("factview_access");
        deleteCookie("factview_refresh"); 
        deleteCookie("session_id");
        window.location.href = 'https://monitor.factview.nl/oauth/index.php?logout=1&client_id='+clientId+'&import_session='+getCookie('session_id');
      }
    }
  }

  async function LogoutExactOnline(){
    let isExecuted = window.confirm(getTranslation("import_LogoutConfirmExactOnline"));
      if(isExecuted)
      {
        const response = await fetch('/app_user/logoutExactOnline?user_id='+await getCurrentUser());
        if (response.ok) {
          const responseData = await response.json();

          window.location.href = 'https://importmodule.factview.nl/app';
        }
      }
  }

  async function LogoutTwinfield(){
    let isExecuted = window.confirm(getTranslation("import_LogoutConfirmTwinfield"));
    if(isExecuted)
    {
      const response = await fetch('/app_user/logoutTwinfield?user_id='+await getCurrentUser());
      if (response.ok) {
        const responseData = await response.json();
      
        window.location.href = 'https://importmodule.factview.nl/app';
      }
    }
  }
  
  function handleClickOutsideClose(event){
    var dropdownEl = document.querySelector(".profile-dropdown-container");
    var headerProfileBtn = document.querySelector(".header-profile-btn");
    var profileCloseBtn = document.querySelector(".profile-close");
    
    if(dropdownEl && !dropdownEl.contains(event.target) && !headerProfileBtn.contains(event.target) && !profileCloseBtn.contains(event.target)){
      dropdownEl.classList.toggle("visible");
      document.removeEventListener('click', handleClickOutsideClose);
    }
  }  

  async function toggleDropdown(event){
    var dropdownEl = document.querySelector(".profile-dropdown-container");
    
    if(dropdownEl.classList.contains("visible")){
      document.removeEventListener('click', handleClickOutsideClose);
    }
    else{
      document.addEventListener('click', handleClickOutsideClose);
    }    

    dropdownEl.classList.toggle("visible");
  }

  async function closeDropdown(){
    var dropdownEl = document.querySelector(".profile-dropdown-container");
    dropdownEl.classList.remove("visible");
    
    document.removeEventListener('click', handleClickOutsideClose);
  }
  
  return (
    <div className="profile-component">   
      <FontAwesomeIcon className="header-profile-btn hover" onClick={(event)=>{toggleDropdown(event)}} icon={faCircleUser}/>
      <div className='profile-dropdown-container'>
        <div className='profile-dropdown'> 
          <div className="profile-header">
            <div className="profile-username">
              <p><FontAwesomeIcon className="username-icon" icon={faUser}/></p>
              <p>{appUser.user_name}</p>
            </div>
            <div className="profile-close hover" onClick={()=>{closeDropdown()}}>
              <FontAwesomeIcon className="profile-close-icon" icon={faXmark}/>
            </div>
          </div>
          <div className="profile-content-container">
            <div className="factview-profile-container">
              <div className="factview-profile-label">
                <p>{getTranslation("import_ImportUser")}</p>
              </div>
              <div className="profile-content factview-profile">
                <p><img src={FactviewLogoSmall} className="profile-content-img" alt="logo" />Factview</p>
                <button className='profile-logout-btn' onClick={()=>{LogoutFactview()}}><FontAwesomeIcon className="logout-icon" icon={faArrowRightFromBracket}/>{getTranslation("import_Logout")}</button>
              </div>
            </div>
            <div className="profile-external-platforms"> 
              <div className="external-platforms-label">
                <p>{getTranslation("import_ConnectedPlatforms")}</p>
              </div>  
              {(!appUser.exactonline_access && !appUser.exactonline_refresh && !appUser.twinfield_access && !appUser.twinfield_refresh) ? (
              <div className="exteral-no-platforms">
                <p>{getTranslation("import_NoUsersConnectedExternal")}</p>
              </div>
              ):(
            <div>
                {(appUser.exactonline_access || appUser.exactonline_refresh) ? (
                <div className="profile-content">
                  <p><img src={ExactSmall} className="profile-content-img" alt="logo" />Exact online</p>
                  <button className='profile-logout-btn' onClick={()=>{LogoutExactOnline()}}><FontAwesomeIcon className="logout-icon" icon={faArrowRightFromBracket}/>{getTranslation("import_Logout")}</button>
                </div>
                ) : null} 
                {(appUser.twinfield_access || appUser.twinfield_refresh) ? (
                  <div className="profile-content">
                    <p><img src={TwinfieldSmall} className="profile-content-img" alt="logo" />Twinfield</p>
                    <button className='profile-logout-btn' onClick={()=>{LogoutTwinfield()}}><FontAwesomeIcon className="logout-icon" icon={faArrowRightFromBracket}/>{getTranslation("import_Logout")}</button>
                  </div>
                ) : null}
              </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileComponent;
